import { useSelector } from 'react-redux';
import { Switch, useLocation } from 'react-router-dom';

import { Home } from 'components/Home';
import { Payment } from 'components/Payment';
import { globalState } from 'store/reducer';
import { SentryRoute } from '../index';

export const Routes = () => {
  const location = useLocation();
  const isNotValidUsersForm = useSelector(
    globalState.selectors.isNotValidUsersForm
  );

  return (
    <Switch>
      <SentryRoute
        path="/"
        exact
        render={() => {
          console.log('beforeEnter home');
          return <Home />;
        }}
      />
      <SentryRoute
        path="/payment"
        render={({ history }) => {
          if (isNotValidUsersForm) {
            localStorage.setItem('phone', '');
            history.push({
              pathname: '/',
              search: location.search,
            });
            return null;
          }
          return <Payment />;
        }}
      />
    </Switch>
  );
};
